var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRefreshIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#667085",
    d: "M4.667 14.333a3 3 0 1 1 0-6 3 3 0 0 1 0 6Zm6.666-6.666a3 3 0 1 1 0-6 3 3 0 0 1 0 6ZM2 5.333A3.333 3.333 0 0 1 5.333 2h2v1.333h-2a2 2 0 0 0-2 2v2H2v-2Zm10.667 3.334v2a2 2 0 0 1-2 2h-2V14h2A3.333 3.333 0 0 0 14 10.667v-2h-1.333Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefreshIcon);
export default __webpack_public_path__ + "static/media/refresh-icon.4937d3497707b578068995bdb6548de3.svg";
export { ForwardRef as ReactComponent };